import { render, staticRenderFns } from "./MobileNavBar.vue?vue&type=template&id=b48cc968&scoped=true"
import script from "./MobileNavBar.vue?vue&type=script&lang=js"
export * from "./MobileNavBar.vue?vue&type=script&lang=js"
import style0 from "./MobileNavBar.vue?vue&type=style&index=0&id=b48cc968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48cc968",
  null
  
)

export default component.exports